import { Alert } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { HangarsStateContainer } from "../../containers/HangarsStateContainer";
import { RampsStateContainer } from "../../containers/RampsStateContainer";
import { RampStateContainer } from "../../containers/RampStateContainer";
import { TowingEquipmentContainer } from "../../containers/TowingEquipmentContainer";
import { RampsPresenter } from "./RampPresenter";

type Props = {
  rampId?: string;
  isReference?: boolean;
};

export const Ramp: React.FC<Props> = ({ rampId, isReference }) => {
  const { t } = useTranslation();
  const { id: rampIdFromRoute } = useParams();

  return (
    // RampsStateContainer and HangarsStateContainer might seem weird. it's for the selection menus
    <RampsStateContainer isReference={isReference ?? false}>
      <HangarsStateContainer isReference={isReference ?? false}>
        <RampStateContainer
          initialState={{
            ramp_id: rampId ?? rampIdFromRoute,
            isReference: isReference ?? false,
          }}
        >
          <TowingEquipmentContainer>
            {isReference && (
              <Alert severity="warning">
                {t('screens.ramp.ramp.referenceModeAlert')}
              </Alert>
            )}
            <RampsPresenter />
          </TowingEquipmentContainer>
        </RampStateContainer>
      </HangarsStateContainer>
    </RampsStateContainer>
  );
};
